export default __webpack_public_path__ + "static/media/priscilla2.c349d4de.jpg";